import React, { useEffect, useRef, useState } from "react";
import { HiOutlineClock } from "react-icons/hi";
import { post } from "../../api";
import { CLEAR_BASKET_URL } from "../../api/apiRoutes";
import useFacility from "../../../utils/hooks/useFacility";
import { useDispatch, useSelector } from "react-redux";
import { State } from "../../store";
import { useTranslation } from "react-i18next";
import { resetBasket } from "../../store/basket/basketActions";

interface IProps {
  onExpired?: () => void;
  clearBasketOnExpire?: boolean;
}

const Timer: React.FC<IProps> = ({ onExpired, clearBasketOnExpire = true }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const timeToBuy = useSelector((state: State) => state.config.configuration.timeToFinishTransaction);
  const facilityIds = useFacility();
  const initialSeconds = timeToBuy && timeToBuy > 0 ? timeToBuy * 60 : 900;
  const [delay, setDelay] = useState(initialSeconds);
  const clearedRef = useRef(false);
  const onExpiredRef = useRef(onExpired);
  onExpiredRef.current = onExpired;

  useEffect(() => {
    const timer = setInterval(() => {
      setDelay((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    if (delay !== 0 || clearedRef.current) {
      return;
    }
    clearedRef.current = true;

    const clearOnExpiry = async () => {
      if (!clearBasketOnExpire) {
        onExpiredRef.current?.();
        return;
      }
      const { isError } = await post(CLEAR_BASKET_URL(facilityIds));
      if (!isError) {
        dispatch(resetBasket());
        onExpiredRef.current?.();
      }
    };
    void clearOnExpiry();
  }, [clearBasketOnExpire, delay, dispatch, facilityIds]);

  const minutes = Math.floor(delay / 60);
  const seconds = Math.floor(delay % 60);

  return (
    <div className="timer-basket flex-center-center">
      <HiOutlineClock className="ticket-line-icon" />
      <span>{t("czas_na_dokonczenie_zakupu")}:</span>
      <b>
        {minutes}m:{seconds}s
      </b>
    </div>
  );
};

export default Timer;
